import dispatchEvent from "./dispatchEvent";

/**
 * This function finds all child images and ensure that they either trigger a resize event
 * when they're loaded, either trigger immedately the resize event if they're cached.
 *
 * This allows parent components to listen to child resize events and recalculate the
 * content size when images are loaded.
 *
 * @param {HTMLElement} container The container element to find image nodes in
 * @returns nothing
 */
export const handleImagesLoading = container => {
  if (!container || !container.querySelectorAll) return;

  // Find all images that were not already processed by this component's
  // instance.
  const images = container.querySelectorAll("img:not([data-height-processed])");

  Object.keys(images).forEach(key => {
    const image = images[key];

    // If the element of the set is not a node pass to the next element
    if (!image || !image.setAttribute) return;

    // Flag the image as being already processed
    image.setAttribute("data-height-processed", true);

    // Trigger a resize event that will make every nested withContentHeight
    // event handlers to force reprocessing their content height now that
    // the image height is known
    const loadingImage = new Image();
    image.onload = () => dispatchEvent(image, "resize");
    loadingImage.src = image.src;
  });
};
